module.exports = function(params) {
    const urlParams = new URLSearchParams(Object.entries(params));
    return urlParams.toString()
}